import React from 'react';
import { useHistory } from 'react-router-dom';

// styling
import { Spacing, Colors } from '_styles';

const MarketplaceFooter = () => {

  // nav
  const history = useHistory();
  
  return (
    <div style={styles.container}>
      <div style={styles.text}>2025 PRM Assist © All rights reserved</div>

      <div
        style={styles.link}
        onClick={() => history.push('/terms-and-conditions')}
      >
        Terms and Conditions
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#e0e0e0',
    padding: Spacing.SCALE_20,
    textAlign: 'center',
  },
  text: {
    color: 'black',
    fontSize: '14px',
    cursor: 'default',
    marginBottom: Spacing.SCALE_10
  },
  link: {
    color: 'black',
    fontSize: '14px',
    cursor: 'pointer',
  },
}

export default MarketplaceFooter;
